import React from 'react';
import {LoadingButton} from '@mui/lab';
import {useSelector} from "react-redux";
import "./ButtonComponent.css";

function ButtonComponent(props) {
    const screenReducer = useSelector(state => state.ScreenReducer);
    const [isTall, setIsTall] = React.useState(true);

    React.useEffect(() => {
        if (screenReducer.screen) {
            let isTallScreen = (screenReducer.screen === 'MD' || screenReducer.screen === 'LG' || screenReducer.screen === 'XL');
            setIsTall((previous) => (previous !== isTallScreen ? isTallScreen : previous));
        }
    }, [screenReducer.screen]);

    return (
        <LoadingButton
            className={`${isTall ? (props.small ? 'buttonSmall' : 'button') : (props.small ? 'buttonVerySmall' : 'buttonSmall')} ${props.className ? props.className : ''}`}
            loading={props.loading}
            disabled={props.disabled}
            variant={props.outlined ? 'outlined' : 'contained'}
            style={props.color ? {
                ...props.style,
                backgroundColor: props.outlined ? 'unset' : props.color,
                color: props.loading ? 'rgba(255,255,255,0)' : (props.outlined ? props.color : '#FFFFFF'),
                borderColor: props.color
            } : {
                ...props.style,
                backgroundColor: props.outlined ? 'unset' : 'var(--thememarron)',
                color: props.loading ? 'rgba(255,255,255,0)' : (props.outlined ? props.color : '#000'),
            }}
            onClick={props.onClick}>
            {props.label}
        </LoadingButton>
    );
}

export default ButtonComponent;
